module.exports = __webpack_public_path__ + "img/4-2.16bc4a16.png";